import ADCallback from './adCallback';

export default ADCallback;
